 
 
 
export function checkPrivilegies() {}

export function platformPrivilegies() {
  const platformState = this.getRootState()
  const isDev =
    platformState.appKey === 'smbls.symbo.ls' ||
    platformState.appKey === 'default.symbo.ls'
  const isAdmin =
    platformState.userId === 'usb148d6dd' ||
    platformState.userId === 'usb8964b6c'
  if (!isDev || (isDev && isAdmin)) {
    return true
  }
}
